import React from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Upload,
  Icon,
  message,
  Row,
  Col
} from 'antd';
import 'whatwg-fetch'
import {intToHexVersion} from '../utils'
import {API_URL} from '../constants/configValues'
const FormItem = Form.Item;
const Dragger = Upload.Dragger;

class SystemHubCheckFirmwareModalForm extends React.Component {
  state = {
    firmwareInfo: undefined,
    saveDisabled: true
  }

  handleBeforeUpload = (file) => {
    const fr = new FileReader();
    fr.onloadend = () => {
      this.setState({firmwareBinaryStr: fr.result})
    }
    fr.readAsBinaryString(file);
  }

  handleCustomRequest = ({onSuccess, onError, file}) => {
    const fr = new FileReader();
    const {system, hub, token} = this.props
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    fr.onloadend = () => {
      fetch(`${API_URL}/v1/systems/${system.ID}/hubs/check-hex-firmware`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ID: hub.ID, FirmwareString: fr.result})
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              onSuccess('done', file);
              this.setState({firmwareInfo: json, saveDisabled: false})
            }).catch(error => {
              onError()
              message.error("Upload firmware lỗi!");
            })
          }
        } else {
          onError()
          message.error("Upload firmware lỗi!");
        }
      }).catch(error => {
        onError()
        message.error("Upload firmware lỗi!");
      })
    }
    fr.readAsBinaryString(file);
  }

  handleSubmit = () => {
    const {hub} = this.props
    const {firmwareInfo} = this.state
    const firmware = {
      ID: hub.ID,
      FirmwareInfo: firmwareInfo,
      ActiveDownloadLimits: []
    }
    this.props.onSubmit(firmware)
  }

  render() {
    const {
      title,
      system,
      hub,
      token,
      visible,
      onCancel,
      form
    } = this.props;
    const {firmwareInfo, saveDisabled} = this.state
    const {getFieldDecorator} = form;

    return (<Modal visible={visible} title={title} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={this.handleSubmit} footer={[
        <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
        <Button key="submit" type="primary" ghost="ghost" disabled={saveDisabled} onClick={this.handleSubmit}>
          Lưu
        </Button>
      ]}>
      <Form layout="vertical">
        <FormItem >
          {getFieldDecorator('ID', {initialValue: hub.ID})(<span/>)}
        </FormItem>
        <Row className="row">
          <Col span={8}>Tên hub</Col>
          <Col span={16}>{hub.Name}</Col>
        </Row>
        <Row className="row">
          <Col span={8}>Firmware cũ</Col>
          <Col span={16}>{intToHexVersion(hub.FirmwareVersion)}</Col>
        </Row>
        {
          firmwareInfo
            ? <Row className="row">
                <Col span={8}>Firmware mới</Col>
                <Col span={16}>{intToHexVersion(firmwareInfo.Version)}</Col>
              </Row>
            : null
        }
        {
          firmwareInfo
            ? <Row className="row">
                <Col span={8}>Firmware size</Col>
                <Col span={16}>{firmwareInfo.Size}</Col>
              </Row>
            : null
        }
        <Dragger beforeUpload={this.handleBeforeUpload} customRequest={this.handleCustomRequest}>
          <p className="ant-upload-drag-icon">
            <Icon type="inbox"/>
          </p>
          <p className="ant-upload-text">Chọn file hoặc kéo thả file để upload firmware</p>
        </Dragger>
      </Form>
    </Modal>);
  }
}

export default Form.create()(SystemHubCheckFirmwareModalForm)



// WEBPACK FOOTER //
// ./src/components/SystemHubCheckFirmwareModalForm.js